
import axios from "axios";

function getClients() {
    return axios.get('api/factura/getClients').then(r => r.data).catch(r => r);
}

function getData(data) {
    return axios.post('api/factura/dataTable', data);
}

function getContractByClient(data) {
    return axios.post('api/factura/getContractByClient', data).then(r => r.data).catch(r => r);
}

function crearFacturaEvento(data) {
    return axios.post('api/factura/crearFacturaEvento', data).then(r => r.data).catch(r => r);
}


function crearFacturaHora(data) {
    return axios.post('api/factura/crearFacturaHora', data).then(r => r.data).catch(r => r);
}

function editarFactura(data) {
    return axios.put('api/factura/editarFactura', data).then(r => r.data).catch(r => r);
}

function traerInfoFactura(data) {
    return axios.post('api/factura/traerInfoFactura', data).then(r => r.data).catch(r => r);
}

function eliminarfactura(data) {
    return axios.delete(`api/factura/${data}`).then(r => r.data).catch(r => r);
}


export {
    getClients,
    getData,
    getContractByClient,
    crearFacturaEvento,
    crearFacturaHora,
    editarFactura,
    traerInfoFactura,
    eliminarfactura
}
